var $2c7a753ed24e9851$exports = {};
$2c7a753ed24e9851$exports = {
    "loading": `Nalaganje...`,
    "placeholder": `Izberite\u{2026}`
};


export {$2c7a753ed24e9851$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
